import React from "react";
import InvImage from "../InvImage";

class SpecularImage extends React.Component {
  render() {
    return (
      <div>
        <InvImage src={this.props.imageSrc} selector={false} />
      </div>
    );
  }
}

export default SpecularImage;
